import PropTypes from 'prop-types';

export * from './card';
export * from './image';
export * from './link';
export * from './ribbon';
export * from './tile';
export * from './typography';
export * from './video';
export * from './menu';
export * from './colourTheme';
export * from './backgroundImageWidth';

export const alignmentBreakpointType = PropTypes.oneOf([
  'Left',
  'Centre',
  'Right',
]);
export const alignmentType = PropTypes.shape({
  desktop: alignmentBreakpointType,
  mobile: alignmentBreakpointType,
});

export const structuredTextType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
});
